import 'ekko-lightbox';

export function open_modal(images,controls) {
	$(images).appendTo("body");
	var images_count = $('.light_box_images').find('img').length;
	var lb;
	var SCROLL = 200;
	$('.thumbnail:first').ekkoLightbox({
		wrapping: false,
		showArrows: false,
		backdrop: 'static',
		onShown: function() {	lb = this;
							}
	});
	$(".ekko-lightbox").on('shown.bs.modal', function(){
	    var that = this;  
	    $(controls).appendTo($(this));
	    $('.modal-content').on('dragstart', function(event) { event.preventDefault(); });
	    //CLOSE
	    $(".c_close").click(function(e){
		    e.preventDefault();
		    $(".ekko-lightbox").modal('toggle');
		});
		//NEXT
		$(".c_next").click(function(e){
		    e.preventDefault();
		    if($(this).hasClass('disabled')) return;
		    lb.navigateRight();
		    disable_navigation(lb._galleryIndex,images_count-1);
		    reset_scroll(that);
		});
		//PREV
		$(".c_prev").click(function(e){
		    e.preventDefault();
		    if($(this).hasClass('disabled')) return;
		    lb.navigateLeft();
		    disable_navigation(lb._galleryIndex,images_count-1);
		    reset_scroll(that);
		});
		//DOWN
		$(".c_movedown").click(function(e){
		    e.preventDefault();
		    if($(this).hasClass('disabled')) return;
		    var elem = $(that).find('.modal-content');
		    manage_updown(elem, SCROLL);
		});
		//UP
		$(".c_moveup").click(function(e){
		    e.preventDefault();
		    if($(this).hasClass('disabled')) return;
		    var elem = $(that).find('.modal-content');
		    manage_updown(elem, -SCROLL);
		});
		//PRINT
		$(".c_print").click(function(e){
		    if($(this).hasClass('disabled'))
		    {	e.preventDefault();
		    	return;
		    }
		    $(this).addClass('disabled');
		});
	});
	$(".ekko-lightbox").on('hide.bs.modal', function(){
	    $('.light_box_images').remove();
	});

	function reset_scroll(elem)
	{	$(elem).find('.modal-content').scrollTop(0);
		$(".c_movedown").removeClass('disabled');
		$(".c_moveup").addClass('disabled');
	}
	function manage_updown(elem, move)
	{	var y = elem.scrollTop();
	    var max = elem[0].scrollHeight - elem[0].clientHeight;
	    y += move;
	    if(y >= max)
	    {	y = max;
	    	$(this).addClass('disabled');
	    }
	    else if(y < 0)
	    {	y = 0;
	    }
	    switch(true)
	    {	case y == 0:
	    		$(".c_movedown").removeClass('disabled');
				$(".c_moveup").addClass('disabled');
				break;
			case y == max:
				$(".c_movedown").addClass('disabled');
				$(".c_moveup").removeClass('disabled');
				break;
			default:
				$(".c_movedown").removeClass('disabled');
				$(".c_moveup").removeClass('disabled');
				break;
		}
		elem.scrollTop(y);
	}
	function disable_navigation(image_index,last_index)
	{	switch(image_index)
		{	case 0:
				$(".c_prev").addClass('disabled');
				break;
			case last_index:
				$(".c_next").addClass('disabled');
				break;
			default:
				$(".c_prev").removeClass('disabled');
				$(".c_next").removeClass('disabled');
		}
	}
}